var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroSignSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 27.6954C29.9507 29.9276 26.612 31.2805 22.9573 31.2805C14.9537 31.2805 8.46552 24.7923 8.46552 16.7887C8.46552 8.78508 14.9537 2.29688 22.9573 2.29688C26.612 2.29688 29.9507 3.64974 32.5 5.882",
    stroke: "#F5F5F5",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.97998 14.0952H23.23",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.97998 20.0952H23.23",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroSignSvgrepoCom);
export default __webpack_public_path__ + "static/media/euro-sign-svgrepo-com.0a734233d54a45a4e8ae296db14f965a.svg";
export { ForwardRef as ReactComponent };